export const ROOBET_URL = "https://roobet.com/?ref=dafaber";
export const KICK_URL = "https://kick.com/dafaber";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PRIZES = [250, 125, 60, 40, 25];
export const EASE = [0.76, 0, 0.24, 1];

export const fmtUsd = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
